app.controller('AccountAddressAddNewController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {
    const newAddress = {}

    $scope.getNewAddress = function () {
        return newAddress;
    }

    $scope.addNewAddress = function (validateFormCallback) {

        $scope.form_disabled = true;
        $rootScope.service.account.addNewAddress(newAddress, function (success, address, messages) {
            $scope.form_disabled = false;
            if (success) {
                $state.go('myba.account-address-edit', {address_id: address._id});
            }
            validateFormCallback(success, messages);
        });


    };

}]);